import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'dms-modal-generico',
    templateUrl: './modal-generico.component.html',
    styleUrls: ['./modal-generico.component.scss']
})
export class ModalGenericoComponent implements OnInit {

    @Input() closable = true;
    @Output() onCloseClick = new EventEmitter<void>()

    constructor() { }

    ngOnInit() {
    }

    close(){
        this.onCloseClick.emit();
    }

}
